module.exports = __webpack_public_path__ + "1_0_60/img/Statue of Liberty.40a500a1.jpg";